import { IFormBuilderItemBase, IFormBuilderItemDataBase, TFormBuilderItem } from "./formBuilderItem";
import { IFormBuilderItemOption } from "./formBuilderItemOption";

type TFormBuilderSelectType = "select";
export type TFormBuilderSelectRole = "custom" | "inquiry";

export interface IFormBuilderSelectSettings {
  label: string;
  placeholder: string;
  required: boolean;
  options: IFormBuilderItemOption[];
}

export interface IFormBuilderSelectData extends IFormBuilderItemDataBase {
  type: TFormBuilderSelectType;
  role: TFormBuilderSelectRole;
  settings: IFormBuilderSelectSettings;
}

export interface IFormBuilderSelect extends IFormBuilderItemBase {
  data: IFormBuilderSelectData;
}

export type TFormBuilderSelectSettings = IFormBuilderSelect["data"]["settings"];

export function isFormBuilderSelectItem(item: TFormBuilderItem): item is IFormBuilderSelect {
  return item.data.type === "select";
}

export function isFormBuilderSelectType(value: string): value is TFormBuilderSelectType {
  return value === "select";
}

export function isFormBuilderSelectRole(value: string): value is TFormBuilderSelectRole {
  return value === "custom" || value === "inquiry";
}

export function formBuilderGenerateDefaultInquirySelect(): IFormBuilderSelect {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "select",
      role: "inquiry",
      settings: {
        label: "Inquiry", // TODO: Translation
        placeholder: "Select a topic", // TODO: Translation
        required: false,
        options: [],
      },
    },
  };
}

export function formBuilderGenerateDefaultCustomSelect(): IFormBuilderSelect {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "select",
      role: "custom",
      settings: {
        label: "Select", // TODO: Translation
        placeholder: "Select an option", // TODO: Translation
        required: false,
        options: [],
      },
    },
  };
}
